export default "__VITE_ASSET__DhCyle9l__"